module.exports = __webpack_public_path__ + "img/ereszkalkulator_haz_kontyolt_nyeregteto_szines.48fecc27.png";